export class ApiErrorResponseDataError {
    public errorCode: string;
    public message: string;
    public status: string;

    constructor(apiErrorResponseDataError?: ApiErrorResponseDataError) {
        this.errorCode = apiErrorResponseDataError && apiErrorResponseDataError.errorCode || null;
        this.message = apiErrorResponseDataError && apiErrorResponseDataError.message || null;
        this.status = apiErrorResponseDataError && apiErrorResponseDataError.status || null;
    }
}
